import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { ReportOutlined } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuReportsProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuReports = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuReportsProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/reports?page=1&page_size=25"
        selected={pathname.startsWith('/live-chat/reports')}
      >
        <ListItemIcon>
          <ReportOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.reports',
          })}
        />
      </MenuItem>
    </div>
  )
}
